<template>
  <div id="myDateShow">
    <div class="title">查看 管理员资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">管理员名称</div>
        <div class="value">{{admin.username}}</div>
      </div>
      <div class="line">
        <div class="key">创建时间</div>
        <div class="value">{{admin.registerTime}}</div>
      </div>
      <div class="line">
        <div class="key">管理员角色</div>
        <div class="value">
          {{admin.roleNames[0]}}
          <el-button style="margin-left: 20px" type="primary" size="medium" @click="toRoleData">查看角色信息</el-button>
        </div>
      </div>
      <div class="line"></div>

    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getAdminById,newVue,setRole} from "../../network/admin";

  export default {
    name: "AdminData",
    components: {},
    data(){
      return{
        adminId:"",
        admin:{
          roleList:[],
          roleNames:[]
        }
      }
    },
    methods:{
      backClick(){
        this.$router.push("../list");
      },
      toRoleData(){
        let role = {};
        role.id = this.admin.roleList[0].id
        role.roleName = this.admin.roleNames[0]
        role.roleResources = this.admin.roleResources;
        setRole(role)
        this.$router.push("/role/data");
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href = "/admin/list";
      this.common.HeaderLocationTwo.name = "平台管理员管理";
      this.common.HeaderLocationThree.name = "管理员详情";
      this.adminId = this.$route.params.id;

      getAdminById(this.adminId).then(res => {
        this.admin = res.data
      })
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
</style>
